import { groupById } from "@/helpers";
import { getFileCategories } from "@/services/common/getFileCategories";
import { getUserFileByCategory } from "@/services/users/getUserFileByCategory";

export async function getFormatedFileByCategory() {
  try {
    const formatedData = [];

    // Wait for the categories to be fetched
    const categories = await getFileCategories();
    const fileIds = categories?.map((x) => x.id);

    // Wait for the files to be fetched by category
    const files = await getUserFileByCategory(fileIds);

    // Group the files by their category ID
    const groupedFiles = await groupById(files, "fileCategoryId");

    // Format the data
    categories?.forEach((category) => {
      formatedData.push({
        id: category.id,
        title: category.name,
        message: `Maximum number of documents allowed is two(${category.limit})`,
        isRequired: false,
        limit: category.limit,
        files: groupedFiles[category.id] || [],
      });
    });

    return formatedData;
  } catch (error) {
    throw error;
  }
}
